/**
 * Mapa do status processual da empresa-alvo (LegalStatus, DOCUMENTACAO.md §4.2) — enum do backend
 * (string) → rótulo e tag do cartão. No mock o cartão mostra uma tag (tom de aviso) só para
 * RE / RJ / Falência; "Nenhum" e "Distressed s/ proteção" não geram tag. O valor numérico é
 * usado no corpo do UpdateDeal (bind de enum por número — sem JsonStringEnumConverter).
 */
export interface LegalStatusDef {
  apiName: string;
  apiValue: number;
  label: string;
  /** Texto da tag no cartão; null = sem tag. */
  cardTag: string | null;
}

export const LEGAL_STATUSES: readonly LegalStatusDef[] = [
  { apiName: 'Nenhum', apiValue: 0, label: 'Sem proteção', cardTag: null },
  { apiName: 'RecuperacaoExtrajudicial', apiValue: 1, label: 'Recup. Extrajudicial', cardTag: 'RE' },
  { apiName: 'RecuperacaoJudicial', apiValue: 2, label: 'Recup. Judicial', cardTag: 'RJ' },
  { apiName: 'Falencia', apiValue: 3, label: 'Falência', cardTag: 'FALÊNCIA' },
  { apiName: 'DistressedSemProtecaoJudicial', apiValue: 4, label: 'Distressed s/ proteção', cardTag: null },
];

const BY_API = new Map(LEGAL_STATUSES.map((s) => [s.apiName, s]));

export function legalStatusByApiName(apiName: string): LegalStatusDef | undefined {
  return BY_API.get(apiName);
}

/** Valor numérico do enum (para o corpo do UpdateDeal); cai para 0 (Nenhum) se desconhecido. */
export function legalStatusValue(apiName: string): number {
  return BY_API.get(apiName)?.apiValue ?? 0;
}
